import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { Container, Row, Col, Button, Input, Modal, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios';
import InputMask from "react-input-mask";
import helpers from "./helpers/Utilities";
import constants from './helpers/Constants';
import './App.css';

function EsqueciSenha() {

    const [cpf, setCPF] = useState('');
    const [senha, setSenha] = useState('');
    const [senha2, setSenha2] = useState('');

    const [showMsg, setShowMsg] = useState(false);
    const [showMsgOK, setShowMsgOK] = useState(false);
    const [msg, setMsg] = useState('');
    const toggleMsg = () => setShowMsg(!showMsg);

    const [validated, setValidated] = useState(false);

    const history = useHistory();

    const handleOK = () => {
        setShowMsgOK(false);
        history.push("/login");
    };

    const handleSalvar = () => {

        // Sem validação de dígito verificador: os CPFs de teste do seed
        // (000.000.000-01) são placeholders e não passam no cálculo. Confere
        // apenas se a máscara foi preenchida por completo, como em Login.js.
        if (cpf.length < 14 || cpf.indexOf('_') !== -1) {
            setMsg('Informe o CPF completo.');
            toggleMsg();
            setValidated(true);
            return;
        }

        if (helpers.isEmpty(senha) || helpers.isEmpty(senha2) || senha.trim().length < 6) {
            setMsg('A nova senha deve ter pelo menos 6 caracteres.');
            toggleMsg();
            setValidated(true);
            return;
        }

        if (senha !== senha2) {
            setMsg('As senhas não conferem.');
            toggleMsg();
            setValidated(true);
            return;
        }

        setValidated(false);

        axios({
            method: 'post',
            url: constants.APIURLGet,
            headers: {
                'APITOKEN': constants.APIToken
            },
            data: {
                query: `select cpf from associado where cpf = '${cpf}'`
            }
        })
        .then(function (response) {
            if (response.data.length === 0) {
                setMsg('O CPF informado não foi encontrado em nosso banco de dados.');
                setShowMsg(true);
                return;
            }

            let cmd = `UPDATE associado SET `;
            cmd += `  senha='${helpers.sha1(senha)}'`;
            cmd += `, senha_atualizada_em=NOW()`;
            cmd += ` WHERE cpf = '${cpf}'`;

            axios({
                method: 'post',
                url: constants.APIURLExec,
                headers: {
                    'APITOKEN': constants.APIToken
                },
                data: {
                    cmd: cmd
                }
            })
            .then(function (response) {
                if (response.data.ok) {
                    setShowMsgOK(true);
                }
                else {
                    setMsg('Não foi possível alterar a senha. Tente novamente.');
                    setShowMsg(true);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        })
        .catch(function (error) {
            console.log(error);
        });
    };

    return (
        <Container>
            <Modal isOpen={showMsg}>
                <ModalBody>
                    {msg}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={toggleMsg}>OK</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={showMsgOK}>
                <ModalBody>
                    Senha alterada com sucesso.
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleOK}>OK</Button>
                </ModalFooter>
            </Modal>
            <Row>
                <Col className="bg-azul text-center pt-3 mt-5" style={{'borderRadius': '30px 30px 0px 0px'}}>
                    <img src="logo.png" alt="Logo FIKM" style={{'width': '40%'}}></img>
                </Col>
            </Row>
            <Row>
                <Col className="bg-azul h5 text-white pt-3 pb-5 text-center mb-5" style={{'borderRadius': '0px 0px 30px 30px'}}>
                    Esqueci minha senha
                </Col>
            </Row>
            <Row>
                <Col>
                    <InputMask mask="999.999.999-99" value={cpf} onChange={(e) => setCPF(e.target.value)} className={`form-control text-center ${(validated && (cpf.length < 14 || cpf.indexOf('_') !== -1) ? 'is-invalid' : '')}`} placeholder="CPF"></InputMask>
                </Col>
            </Row>
            <Row>
                <Col className="mt-3">
                    <Input className={`form-control text-center ${(validated && (helpers.isEmpty(senha) || senha.trim().length < 6) ? 'is-invalid' : '')}`} type="password" placeholder="Defina uma nova senha" value={senha} onChange={(e) => setSenha(e.target.value)} ></Input>
                </Col>
            </Row>
            <Row>
                <Col className="mt-3">
                    <Input className={`form-control text-center ${(validated && (helpers.isEmpty(senha2) || senha2.trim().length < 6 || senha !== senha2) ? 'is-invalid' : '')}`} type="password" placeholder="Repita a nova senha" value={senha2} onChange={(e) => setSenha2(e.target.value)} ></Input>
                </Col>
            </Row>
            <Row>
                <Col className="mt-3">
                    <Button onClick={handleSalvar} className="btn btn-block btn-lg btn-primary btn-azul">SALVAR</Button>
                </Col>
            </Row>
            <Row>
                <Col className="mt-2">
                    <Button href="/login" className="btn btn-block btn-lg btn-outline-primary btn-outline-azul">VOLTAR</Button>
                </Col>
            </Row>
        </Container>
    );
}

export default EsqueciSenha;
